export const COLUMN_HEADERS = {
  Planned: "Planned",
  Actuals: "Actuals",
  "Planned v Actual Indicators": "Impact",
  ToolTips: "",
};
